import { action, payload } from 'ts-action'
import { IPayload } from 'models/Global'
import { IFavorite } from 'models/Favorite'

export const FavoriteUpshifter = action('FavoriteUpshifter', payload<IPayload<IFavorite>>())
export const UnfavoriteUpshifter = action('UnfavoriteUpshifter', payload<number>())
export const FavoriteButtonLoading = action('FavoriteButtonLoading', payload<number>())
export const FavoriteButtonStopLoading = action('FavoriteButtonStopLoading', payload<number>())
